module.exports = __webpack_public_path__ + "static/media/site-logo.a692708c.svg";